(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["text-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".tab-buttons button");
  const items = document.querySelectorAll(".tab-item");

  function updateDisplay(selectedTab) {
    items.forEach(item => {
      const tabs = item.dataset.tabs.split(',').map(t => t.trim().toLowerCase());
      if (tabs.includes(selectedTab)) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }

  const firstTab = buttons[0]?.dataset.tab.toLowerCase().trim();
  if (firstTab) updateDisplay(firstTab);

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      buttons.forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");
      updateDisplay(button.dataset.tab.toLowerCase().trim());
    });
  });
});


  } catch(e) { console.error(e); }
})();
})();
